import { render, staticRenderFns } from "./OperationMould.vue?vue&type=template&id=95ad8900&scoped=true&"
import script from "./OperationMould.vue?vue&type=script&lang=js&"
export * from "./OperationMould.vue?vue&type=script&lang=js&"
import style0 from "./OperationMould.vue?vue&type=style&index=0&id=95ad8900&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ad8900",
  null
  
)

export default component.exports